import type { Ref } from 'react';
import { type ButtonHTMLAttributes } from 'react';
import { Dialog } from '@base-ui/react/dialog';
import { ButtonControl } from './ButtonControl';
import { Icon } from './Icon';
import { cx } from '../lib/cx';
import { useModalFrame } from '../lib/modalContext';

export function ModalCloseButton(
  { ref, className, disabled, ...props }: Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children' | 'onClick'> & { ref?: Ref<HTMLButtonElement> },
) {
  const frame = useModalFrame();
  const ariaLabel = props['aria-label'] ?? (props['aria-labelledby'] ? undefined : props.title);
  const glyph = <span className="modal-close-dot"><Icon name="i-window-close" viewBox="0 0 16 16" /></span>;
  return <Dialog.Close render={<ButtonControl />} ref={ref} className={cx('modal-close', className)} disabled={disabled || frame?.busy} {...props} aria-label={ariaLabel}>
    {glyph}
  </Dialog.Close>;
}
